import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

export const orgUnitLevelKeys = {
    all: ['orgUnitLevels'],
    lists: () => [...orgUnitLevelKeys.all, 'list'],
    list: (filters) => [...orgUnitLevelKeys.lists(), filters],
    details: () => [...orgUnitLevelKeys.all, 'detail'],
    detail: (id) => [...orgUnitLevelKeys.details(), id],
};

// Fetch all org unit levels
export function useOrgUnitLevels(filters = {}, options = {}) {
    const { orgId, ...restFilters } = filters;
    return useQuery({
        queryKey: orgUnitLevelKeys.list(filters),
        queryFn: () => apiHelper.getResource('/rbac/org-unit-levels/', {
            orgId,
            params: { ...(orgId && { org: orgId }), ...restFilters },
        }),
        ...options,
    });
}

// Fetch single org unit level
export function useOrgUnitLevel(id) {
    return useQuery({
        queryKey: orgUnitLevelKeys.detail(id),
        queryFn: () => apiHelper.getResource(`/rbac/org-unit-levels/${id}/`),
        enabled: !!id,
    });
}

// Create org unit level
export function useCreateOrgUnitLevel() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => apiHelper.postResource('/rbac/org-unit-levels/', data, { orgId: data.org }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: orgUnitLevelKeys.lists() });
        },
    });
}

// Update org unit level
export function useUpdateOrgUnitLevel() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }) => apiHelper.putResource(`/rbac/org-unit-levels/${id}/`, data, { orgId: data.org }),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: orgUnitLevelKeys.lists() });
            queryClient.invalidateQueries({ queryKey: orgUnitLevelKeys.detail(id) });
        },
    });
}

// Delete org unit level
export function useDeleteOrgUnitLevel() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id) => apiHelper.deleteResource(`/rbac/org-unit-levels/${id}/`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: orgUnitLevelKeys.lists() });
        },
    });
}
